import { FullProjectInvoice, ProjectInvoice } from '../types';
import { executeApiCall } from 'services/api';
import { getMutations } from 'entities/hooks/mutation';

import { SuccessData } from 'types/api';

interface ProjectInvoiceDiscountRequestAnswerParams {
  project: string;
  projectInvoice: string;
  request: string;
  approved: boolean;
  comment: string;
  percentage?: string;
}

interface ProjectInvoiceDiscountRequestParams {
  percentage: string;
  requestComment: string;
  project: string;
  projectInvoice: string;
  salesDefined: boolean;

  type: 'PERCENTAGE' | 'VALUE';
  value?: string;
}

type CreateProjectInvoiceParams = Pick<
  ProjectInvoice,
  'client' | 'extraInformation' | 'sampleIds' | 'country' | 'value'
> & {
  project: string;
  quotationRequest?: string;
  discountRequest?: {
    percentage: string;
    requestComment: string;
    salesDefined?: boolean;
  };
};

export const projectInvoicesMutations = getMutations({
  reviewProjectInvoiceDiscountRequest: {
    action: async (payload: ProjectInvoiceDiscountRequestAnswerParams): Promise<SuccessData> => {
      return executeApiCall({
        path: 'invoice/projects/invoices/discount-requests',

        method: 'put',

        payload,
      });
    },

    messages: {
      success: (t) => t('answer-sent')!,

      error: (t) => t('error-while-saving-your-answer')!,
    },
  },

  createProjectInvoiceDiscountRequest: {
    action: async (payload: ProjectInvoiceDiscountRequestParams): Promise<SuccessData> => {
      return executeApiCall({
        path: '/invoice/projects/invoices/discount-requests',

        payload,
      });
    },

    messages: {
      success: (t) => t('answer-sent')!,

      error: (t) => t('error-while-saving-your-answer')!,
    },
  },

  cancelProjectInvoice: {
    action: async (payload: {
      project: string;
      projectInvoice: string;
      justification: string;
    }): Promise<SuccessData> => {
      return executeApiCall({
        path: '/invoice/projects/invoices/cancel',

        payload,
      });
    },

    messages: {
      success: (t) => ({
        title: t('project-invoice-canceled'),
        type: 'success',
      }),
    },
  },

  createProjectInvoice: {
    action: async (payload: CreateProjectInvoiceParams): Promise<FullProjectInvoice> => {
      return executeApiCall({
        path: '/invoice/projects/invoices',

        payload,
      });
    },

    messages: {
      error: (t) => ({
        title: t('failed-to-create-project-invoice'),
        type: 'error',
      }),
    },
  },
});
